const ColorKeys = {
  Blue: 0x86bfda,
  Khaki: 0xdabf86,
  Red: 0xda86bf,
  Green: 0x86dabf,
  Grey: 0xcccccc,
  Black: 0x000000,
};

export default ColorKeys;
